import { schema } from 'normalizr';
import assetSchema from './asset_schema';

const findingSchema = new schema.Entity('findings', {
  assets: [assetSchema],
  catalog_entries: [new schema.Entity('catalog_entries')],
});

export default findingSchema;
